import React, { Dispatch, SetStateAction, useState } from 'react';
import { MyPlanDetails } from 'features/subscription/components/MyPlanDetails';
import { PlanType } from 'features/subscription/components/MySubscription';
import { AllPlans } from 'features/subscription/components/Plans';
import { useTranslation } from 'hooks/useTranslation';

type AvailablePlansType = {
  subscriptionButtonDisabled: boolean;
  setSubscriptionButtonDisabled: Dispatch<SetStateAction<boolean>>;
};

const AvailablePlans: React.FC<AvailablePlansType> = ({
  subscriptionButtonDisabled,
  setSubscriptionButtonDisabled,
}) => {
  const {
    i18n: { language },
  } = useTranslation();
  const [currency, setCurrency] = useState<string>(language == 'ar' ? 'sar' : 'usd');

  return (
    <div>
      <MyPlanDetails
        subscriptionButtonDisabled={subscriptionButtonDisabled}
        setSubscriptionButtonDisabled={setSubscriptionButtonDisabled}
      />
      <PlanType onChangeCurrency={value => setCurrency(value)} currency={currency} />
      <AllPlans
        subscriptionButtonDisabled={subscriptionButtonDisabled}
        setSubscriptionButtonDisabled={setSubscriptionButtonDisabled}
        currency={currency}
      />
    </div>
  );
};

export default AvailablePlans;
